// extracted by mini-css-extract-plugin
module.exports = {"main":"upload_main__dn9nU","full":"upload_full__3DMkm","uploadIcon":"upload_uploadIcon__1wCiW","uploadText":"upload_uploadText__2CVa7","uploadImg":"upload_uploadImg__17n-C"};